import { useLang } from 'hooks/lang';

import { DatePicker, Row, Label } from 'components/Blocks';

import { FormControlHook } from 'hooks';

import { getDateToLocaleStartOfDay } from 'utils/date';

interface PaymentDateProps
  extends Pick<FormControlHook<{ date: string | null }>, 'state' | 'dispatch'> {
  children?: never;
}

export function PaymentDate({ state, dispatch }: PaymentDateProps): JSX.Element {
  const { t } = useLang();

  const handleDateChange = (date: Date | undefined): void => {
    if (!date) return;

    dispatch({
      date: getDateToLocaleStartOfDay(date),
    });
  };

  const { date } = state;

  return (
    <Row justifyContent="space-between">
      <Label>{t('payment-date')}</Label>

      <DatePicker
        disableFuture
        selected={date ? new Date(date) : undefined}
        onSelect={handleDateChange}
      />
    </Row>
  );
}
